import {
  BaseFieldWidget,
  BaseTableFieldWidgetProps,
  BooleanHelper,
  ModelFieldType,
  RowContext,
  RuntimeModelField,
  SPI,
  TableBooleanFieldWidget,
  ViewType,
  Widget,
  enumFetchLabelByValue
} from '@kunlun/dependencies';
import { VNode, createVNode } from 'vue';
import { OioSwitch } from '@kunlun/vue-ui-antd';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Table,
    ttype: ModelFieldType.Boolean,
    widget: 'SwitchComp',
    multi: false
  })
)
export class TableBooleanSwitchCompFieldWidget extends TableBooleanFieldWidget {
  initialize(props: BaseTableFieldWidgetProps<RuntimeModelField>): this {
    super.initialize(props);
    return this;
  }

  @Widget.Method()
  public renderDefaultSlot(context: RowContext): VNode[] | string {
    const value = BooleanHelper.toBoolean(this.compute(context));
    const options = this.getDsl().options || [];
    let resultValue;
    if (options && options.length) {
      resultValue = enumFetchLabelByValue(
        value,
        options.map((o) => {
          return {
            ...o,
            value: o.name
          };
        })
      );
    } else if (value === true) {
      resultValue = this.translate('kunlun.fields.boolean.true');
    } else if (value === false) {
      resultValue = this.translate('kunlun.fields.boolean.false');
    } else {
      resultValue = value;
    }
    return [
      createVNode(OioSwitch, {
        checked: value,
        onChange: (val) => {
          this.dataSource![context.index][this.itemName] = val;
        }
      })
    ];
  }
}
